function StatusIcon({ status }) {
  let primaryColour = "";
  let secondaryColour = "";

  switch (status) {
    case "approved":
      primaryColour = "#198754";
      secondaryColour = "#deffbb";
      break;

    case "pending":
      primaryColour = "#ffb020";
      secondaryColour = "#ffefc5";
      break;

    case "rejected":
      primaryColour = "#f33838";
      secondaryColour = "#ffd5d5";
      break;

    default:
      break;
  }

  return (
    <div
      className={`mx-auto px-[1rem] py-[0.5rem] w-fit flex items-center justify-center gap-2 rounded-full font-semibold text-[${primaryColour}] bg-[${secondaryColour}]`}
    >
      <div className={`w-3 h-3 rounded-full bg-[${primaryColour}]`}></div>
      <span className="capitalize">{status}</span>
    </div>
  );
}

export default StatusIcon;
